import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { APOLLO_CLIENT_CONFIG} from './constants.js';
import { getAPIURL } from '../../../helper/helper.js'
import { clientRequestID } from './util.js';

const apiURL = getAPIURL();

const httpLink = createHttpLink({
	uri: `${apiURL}/graphql`,
	credentials: 'same-origin',
	fetchOptions: {
		mode: 'cors'
	},
	headers: {
		'x-app-id': APOLLO_CLIENT_CONFIG.APP_ID,
		'client-request-id': clientRequestID()
	}
});

const httpLinkDS = createHttpLink({
	uri: `${apiURL}/channelperformance/guided-insights/graphql`,
	credentials: 'same-origin',
	fetchOptions: {
		mode: 'cors'
	},
	headers: {
		'x-app-id': APOLLO_CLIENT_CONFIG.APP_ID,
		'client-request-id': clientRequestID()
	}
});

export const apolloClient = new ApolloClient({
	cache: new InMemoryCache(),
	link: httpLink,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'network-only'
		}
	}
});

export const apolloClientWithoutCache = new ApolloClient({
	cache: new InMemoryCache(),
	link: httpLink,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'no-cache',
			errorPolicy: 'ignore',
		},
		query: {
			fetchPolicy: 'no-cache',
			errorPolicy: 'all',
        }
	}
});

export const apolloClientDS = new ApolloClient({
	cache: new InMemoryCache(),
	link: httpLinkDS,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'network-only'
		}
	}
});